/*
 * Copyright (c) 2021. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <https://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PhoneCallsService {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/phone_call_records', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((phoneCall: any) => {
          return phoneCall;
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }
}
